import {AxiosInstance, leadApiGet, leadApiPost} from "./api";
import {IS_DEV_MODE} from "../constants";

const baseUrl = IS_DEV_MODE
  ? "https://calendar.staging.labs.lixil.com"
  : "https://calendar.prod.labs.lixil.com";

const postAuthData = {
  "password": "QC@123",
  "username": "QC"
}

export const postSignInAuth = async () => {
  // return await leadApiPost("https://calendar.prod.labs.lixil.com/v1/sign-in", postData);
  const postAuthResponse = await leadApiPost(baseUrl + "/v1/sign-in", postAuthData);
  if (postAuthResponse && postAuthResponse.data && postAuthResponse.data.data && postAuthResponse.data.data.jwtToken) {
    // dispatch(setAppJwtToken(postAuthResponse.data.data.jwtToken)); // just in case, we don't need it anymore
    AxiosInstance.defaults.headers.post['Authorization'] = postAuthResponse.data.data.jwtToken;
    AxiosInstance.defaults.headers.get['Authorization'] = postAuthResponse.data.data.jwtToken;
  }
  // console.log("AxiosInstance", AxiosInstance);
  return postAuthResponse
}

const withSignInRetryRequest = async (request) => {
  let mainResponse;

  const retryFunction = async () => {
    console.log("session expired, trying one more time...", );
    // delete AxiosInstance.defaults.headers.post['Authorization']; // prevent status 400 bad request
    // delete AxiosInstance.defaults.headers.get['Authorization']; // prevent status 400 bad request
    await postSignInAuth();
    return await request();
  }

  try {
    mainResponse = await request();
    if (mainResponse && mainResponse.status === 401) {
      mainResponse = await retryFunction();
    }
    return mainResponse
  } catch (error) {
    if ((typeof error === "object") && error.response && (error.response.status === 401)) {
      mainResponse = await retryFunction();
      return mainResponse
    }
    console.log("response error", error);
    return new Error(error)
  }
}


export const checkLixilPostalCode = async (zipCode) => {
  try {
    const url = `${baseUrl}/availability/${zipCode}`;
    const request = leadApiGet.bind(this, url);
    const mainResponse = await withSignInRetryRequest(request);
    return mainResponse && mainResponse.data && mainResponse.data.serviceAvailable
  } catch (error) {
    console.log("availability/postalCode error", error);
    return false
  }
}

export const postLixilCalendar = async (postCalendarData) => {
  try {
    const url = `${baseUrl}/availability/calendar`;
    const request = leadApiPost.bind(this, url, postCalendarData);
    return await withSignInRetryRequest(request);
  } catch (error) {
    console.log("availability/calendar error", error);
    return false
  }
}

export const postLixilGetSalesRep = async (postData) => {
  try {
    const url = `${baseUrl}/availability/getSalesRep`;
    const request = leadApiPost.bind(this, url, postData);
    return await withSignInRetryRequest(request);
  } catch (error) {
    console.log("availability/getSalesRep error", error);
    return false
  }
}
